
import { defineComponent } from 'vue'
import CardTopRightButton from '@/components/CardTopRightButton.vue'
import { useCurrentBuildingId } from '@/composables/currentBuildingId'

export default defineComponent({
  components: { CardTopRightButton },
  setup() {
    return {
      getCurrentBuildingId: useCurrentBuildingId()
    }
  },
  data() {
    return {
      buildingId: '' as string | undefined
    }
  },
  methods: {
    flexhorizonRegistration() {
      const registerURL = process.env.VUE_APP_FLEX_HORIZON_REGISTER_URL + `?building_id=${this.buildingId}`
      window.open(registerURL, '_blank')
    }
  },
  async beforeMount() {
    this.buildingId = await this.getCurrentBuildingId()
  }
})
